var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import * as React from 'react';

var withPaddingAndMargin = function withPaddingAndMargin(WrappedComponent) {
  return function (props) {
    var className = props.className,
        pb = props.pb,
        pt = props.pt,
        pl = props.pl,
        pr = props.pr,
        mb = props.mb,
        mt = props.mt,
        ml = props.ml,
        mr = props.mr,
        otherProps = _objectWithoutProperties(props, ['className', 'pb', 'pt', 'pl', 'pr', 'mb', 'mt', 'ml', 'mr']);

    var paddingBottom = pb ? 'dd-pb-' + pb : '';
    var paddingTop = pt ? 'dd-pt-' + pt : '';
    var paddingLeft = pl ? 'dd-pl-' + pl : '';
    var paddingRight = pr ? 'dd-pr-' + pr : '';
    var marginBottom = mb ? 'dd-mb-' + mb : '';
    var marginTop = mt ? 'dd-mt-' + mt : '';
    var marginLeft = ml ? 'dd-ml-' + ml : '';
    var marginRight = mr ? 'dd-mr-' + mr : '';
    var classNames = [paddingBottom, paddingTop, paddingLeft, paddingRight, marginBottom, marginTop, marginLeft, marginRight, className].join(' ').trim();
    return React.createElement(WrappedComponent, _extends({
      className: classNames
    }, otherProps));
  };
};

export default withPaddingAndMargin;